import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function UnsubscribePage() {
  const { t } = useTranslation("auth");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? undefined;
  const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");

  useEffect(() => {
    document.title = "Unsubscribe — Content OS";
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!token) {
        setStatus("error");
        return;
      }
      try {
        const res = await fetch(
          `/api/u/unsubscribe?token=${encodeURIComponent(token)}`,
          { cache: "no-store" },
        );
        if (!cancelled) setStatus(res.ok ? "ok" : "error");
      } catch {
        if (!cancelled) setStatus("error");
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div
      style={{
        fontFamily: "system-ui, sans-serif",
        maxWidth: 560,
        margin: "64px auto",
        padding: "0 24px",
      }}
    >
      <h1 style={{ fontSize: 20, margin: 0 }}>Content OS</h1>
      <div style={{ marginTop: 24 }}>
        {status === "loading" ? (
          <p>{t("unsubscribe.processing")}</p>
        ) : status === "ok" ? (
          <>
            <h2 style={{ fontSize: 18 }}>{t("unsubscribe.successTitle")}</h2>
            <p>{t("unsubscribe.successMessage")}</p>
            <p>
              <a href="/settings/notifications">{t("unsubscribe.reEnable")}</a>
            </p>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: 18 }}>{t("unsubscribe.errorTitle")}</h2>
            <p>{t("unsubscribe.errorMessage")}</p>
          </>
        )}
      </div>
    </div>
  );
}
